define('home/views/ActivityFooterPostView',[
    'underscore',

    'home/views/common/ActivityFooterView',

    'home/templates/activityFooterPost',
], function (
    _,

    ActivityFooterView,

    activityFooterPostTemplate
) {
    'use strict';

    var ActivityFooterPostView = ActivityFooterView.extend({
        template: activityFooterPostTemplate,
        templateHelpers: function () {
            return _.defaults({
                hasMultiplePosts: this.model.activities.length > 1,
            },
            ActivityFooterView.prototype.templateHelpers.apply(this, arguments));
        },
    });

    return ActivityFooterPostView;
});

